/* NUVRA - punte Easybox intre formularul EasySell si selectorul RoConnect.
 * RoConnect: panoul [data-rc-quickcart-shipping] este legat automat de scriptul aplicatiei (MutationObserver),
 * harta lui scrie lockerul in atributele cosului (Locker ID, Sameday Locker ID, ...).
 * Puntea citeste acele atribute din /cart.js si le trimite in comanda prin window.ES_ADDITIONAL_DETAILS
 * (hook EasySell adaugat la datele comenzii la trimitere). Nu atinge codul intern al aplicatiilor. */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('nvx-es') || window.__nvxEs) return;
  window.__nvxEs = true;

  var EBOX = /easybox|point/i;
  var LOCKER_KEYS = ['Selected Delivery Method', 'Locker Courier', 'Locker ID', 'Locker Address', 'Locker Street',
    'Locker City', 'Locker County', 'Locker Postal Code', 'Sameday Locker ID', 'Sameday Locker Address', 'Sameday Locker Raw'];
  var RC_ORIGIN = 'https://roconect-production.up.railway.app';
  var locker = null;      // atributele lockerului, exact cum le-a scris RoConnect in cos
  var mode = 'home';
  var savedStreet = null;

  function setDetails() {
    var d = { 'Selected Delivery Method': { title: 'Selected Delivery Method', value: mode === 'easybox' ? 'easybox' : 'home' } };
    if (mode === 'easybox' && locker) LOCKER_KEYS.forEach(function (k) { if (locker[k]) d[k] = { title: k, value: String(locker[k]) }; });
    // Un singur rand cu tot ce trebuie pentru AWB-ul facut manual in Sameday.
    var summary = mode === 'easybox'
      ? (locker ? 'EASYBOX · ID ' + (locker['Sameday Locker ID'] || locker['Locker ID'] || '?') + ' · ' + [locker['Locker Address'], locker['Locker Street']].filter(Boolean).join(', ') : '')
      : 'ACASĂ · ' + [optionText('province'), optionText('city'), (fieldInput('address') || {}).value, (fieldInput('nvx_bloc') || {}).value, (fieldInput('zip') || {}).value].filter(Boolean).join(', ');
    if (summary) d['Livrare (pentru AWB)'] = { title: 'Livrare (pentru AWB)', value: summary };
    window.ES_ADDITIONAL_DETAILS = d;
  }

  function rcPanel() {
    var p = document.getElementById('nvx-rc-panel');
    if (p) return p;
    p = document.createElement('div');
    p.id = 'nvx-rc-panel';
    p.className = 'rc-ship-panel';
    p.setAttribute('data-rc-quickcart-shipping', '');
    p.setAttribute('aria-hidden', 'true');
    p.innerHTML = '<div class="rc-ship-panel__options">' +
      '<label class="rc-ship-panel__option" data-rc-option="home"><input class="rc-ship-panel__radio" type="radio" name="nvx-rc" value="home" tabindex="-1"></label>' +
      '<label class="rc-ship-panel__option" data-rc-option="easybox"><input class="rc-ship-panel__radio" type="radio" name="nvx-rc" value="easybox" tabindex="-1"></label></div>' +
      '<div class="rc-ship-panel__easybox-info" hidden><span class="rc-ship-panel__easybox-address"></span>' +
      '<button type="button" class="rc-ship-panel__change-btn" tabindex="-1"></button></div>';
    document.body.appendChild(p);
    return p;
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function lockerFrom(attrs) {
    attrs = attrs || {};
    return attrs['Selected Delivery Method'] === 'easybox' && attrs['Locker ID'] ? attrs : null;
  }

  // ─── Formularul EasySell ────────────────────────────────────────────────────
  function form() { return document.getElementById('easysell'); }

  // Structura EasySell: .es-shipping_options-group > .shipping-container > .shipping-line (.es-selected-shipping-line).
  function selectedMode() {
    var f = form();
    var on = f && f.querySelector('.es-selected-shipping-line .shipping-name');
    return on && EBOX.test(on.textContent || '') ? 'easybox' : 'home';
  }

  function group(name) { var f = form(); return f && f.querySelector('.es-' + name + '-group'); }
  function fieldInput(name) { var g = group(name); return g && g.querySelector('input'); }
  function fieldSelect(name) { var g = group(name); return g && g.querySelector('select'); }
  function optionText(name) { var el = fieldSelect(name); return el && el.value ? (el.selectedOptions[0] || {}).textContent.trim() : ''; }
  var norm = function (x) { return String(x || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); };
  function pickOption(el, wanted) {
    if (!el || !wanted) return false;
    var w = norm(wanted);
    var o = [].find.call(el.options, function (x) { return x.value && norm(x.textContent) === w; }) ||
      [].find.call(el.options, function (x) { return x.value && norm(x.textContent).slice(-w.length - 1) === ' ' + w; });
    if (!o) return false;
    if (el.value !== o.value) {
      Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set.call(el, o.value);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }
  // Easybox: judetul si localitatea vin din locker (clientul nu mai completeaza nicio adresa). Daca nu se potrivesc, raman vizibile.
  var localityOk = false, localityTries = {};
  function fillLocality() {
    localityOk = false;
    if (mode !== 'easybox' || !locker) return;
    if (!pickOption(fieldSelect('province'), locker['Locker County'])) return;
    localityOk = pickOption(fieldSelect('city'), locker['Locker City']);
    // Lista de localitati se incarca dupa schimbarea judetului: cateva reincercari, apoi clientul alege singur.
    var id = locker['Locker ID'] || '';
    if (!localityOk && (localityTries[id] = (localityTries[id] || 0) + 1) <= 8) setTimeout(render, 400);
  }

  function setValue(input, v) {
    if (!input || input.value === v) return;
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, v);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function box() {
    var f = form();
    var list = f && f.querySelector('.es-shipping_options-group .shipping-container');
    if (!list) return null;
    var b = f.querySelector('.nvx-locker');
    if (b) return b;
    b = document.createElement('div');
    b.className = 'nvx-locker';
    b.hidden = true;
    b.innerHTML = '<p class="nvx-locker__title">Easybox / Sameday Point ales</p><p class="nvx-locker__addr" data-nvx-addr></p>' +
      '<button type="button" class="nvx-locker__btn" data-nvx-pick>Alege easybox-ul pe hartă</button><p class="nvx-locker__err" data-nvx-err role="alert"></p>';
    list.parentNode.insertBefore(b, list.nextSibling);
    b.querySelector('[data-nvx-pick]').addEventListener('click', function (e) { e.preventDefault(); pick(); });
    return b;
  }

  // Cum plateste clientul, sub alegerea livrarii: domiciliu = ramburs la curier; easybox = card la terminalul lockerului (Sameday nu primeste numerar la easybox).
  var PAY = { home: 'Plătești la curier, la primirea coletului.', easybox: 'Plătești cu cardul la Easybox, când ridici coletul.' };
  function payNote() {
    var f = form();
    var list = f && f.querySelector('.es-shipping_options-group .shipping-container');
    if (!list) return null;
    var n = f.querySelector('.nvx-pay');
    if (n) return n;
    n = document.createElement('p');
    n.className = 'nvx-pay';
    n.setAttribute('aria-live', 'polite');
    list.parentNode.insertBefore(n, list.nextSibling);
    return n;
  }

  // Scrie doar daca difera: altfel observatorul de mai jos ar reporni la nesfarsit.
  function text(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  function render() {
    var b = box();
    var m = selectedMode();
    if (m !== mode) {
      if (m === 'easybox' && fieldInput('address')) savedStreet = fieldInput('address').value;
      mode = m;
      var p = rcPanel();
      if (mode === 'home') {
        var h = p.querySelector('[data-rc-option="home"]');
        if (h && locker) h.click();      // RoConnect sterge lockerul din cos
        locker = null;
      }
    }
    var street = fieldInput('address');
    ['address', 'nvx_bloc', 'zip'].forEach(function (n) { var g = group(n); if (g) g.classList.toggle('nvx-hide-field', mode === 'easybox'); });
    fillLocality();
    ['province', 'city'].forEach(function (n) { var g = group(n); if (g) g.classList.toggle('nvx-hide-field', mode === 'easybox' && localityOk); });
    // Easybox: strada vine din locker (campul e ascuns); la revenirea pe domiciliu clientul isi regaseste strada scrisa.
    // Judetul/localitatea raman ale clientului; adresa spune clar lockerul (ID-ul lui pleaca separat, in atribute).
    if (mode === 'easybox') setValue(street, locker ? [locker['Locker Address'], locker['Locker Street']].filter(Boolean).join(', ') : '');
    else if (savedStreet !== null) { setValue(street, savedStreet); savedStreet = null; }
    if (b) {
      if (b.hidden !== (mode !== 'easybox')) b.hidden = mode !== 'easybox';
      text(b.querySelector('[data-nvx-addr]'), locker ? (locker['Locker Address'] || '') : '');
      text(b.querySelector('[data-nvx-pick]'), locker ? 'Schimbă easybox-ul' : 'Alege easybox-ul pe hartă');
      if (locker) text(b.querySelector('[data-nvx-err]'), '');
    }
    text(payNote(), PAY[mode]);
    setDetails();
  }

  function pick() {
    var p = rcPanel();
    var info = p.querySelector('.rc-ship-panel__easybox-info');
    var target = locker && info && !info.hidden ? p.querySelector('.rc-ship-panel__change-btn') : p.querySelector('[data-rc-option="easybox"]');
    if (target) target.click();
  }

  // RoConnect anunta alegerea prin postMessage; sursa de adevar raman atributele scrise in cos.
  window.addEventListener('message', function (e) {
    if (e.origin !== RC_ORIGIN || !e.data || e.data.type !== 'locker-selected') return;
    var want = String((e.data.payload || {}).lockerId || '');
    var tries = 0;
    (function poll() {
      readCart().then(function (c) {
        var l = lockerFrom(c.attributes);
        if (l && String(l['Locker ID']) === want) { locker = l; render(); }
        else if (++tries < 20) setTimeout(poll, 250);
      }).catch(function () { if (++tries < 20) setTimeout(poll, 250); });
    })();
  });

  // Fara locker ales, comanda Easybox nu pleaca.
  document.addEventListener('click', function (e) {
    var f = form();
    var btn = f && e.target.closest && e.target.closest('#easysell button, #easysell [role="button"]');
    if (!btn || btn.closest('.nvx-locker') || !/Finalizeaz|TRIMITE COMANDA/i.test(btn.textContent || '')) return;
    setDetails();
    if (selectedMode() === 'easybox' && !locker) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var b = box();
      if (b) { text(b.querySelector('[data-nvx-err]'), 'Alege easybox-ul în care vrei să primești coletul.'); b.scrollIntoView({ block: 'center' }); }
    }
  }, true);

  // Dupa un click in formular EasySell isi redeseneaza linia selectata asincron: reverificam de cateva ori.
  function soon() { [0, 60, 250, 700].forEach(function (ms) { setTimeout(render, ms); }); }
  document.addEventListener('change', function (e) { if (form() && form().contains(e.target)) soon(); }, true);
  document.addEventListener('click', function (e) { if (form() && form().contains(e.target)) soon(); }, true);

  function boot() {
    rcPanel();
    readCart().then(function (c) { locker = lockerFrom(c.attributes); }).catch(function () {}).then(function () {
      setDetails();
      var pending = false;
      new MutationObserver(function () {
        if (pending || !form()) return;
        pending = true;
        setTimeout(function () { pending = false; render(); }, 40);
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Plasa de siguranta: daca aplicatia EasySell nu se incarca deloc, cosul revine la butonul temei (altfel clientul ar ramane fara buton de comanda).
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (window.ES_CONFIG || document.querySelector('.es-popup-button')) return;
      document.documentElement.classList.remove('nvx-es');
      if (window.NuvraPageCart) window.NuvraPageCart.refresh();
    }, 8000);
  });

  window.NuvraEasySell = { state: function () { return { mode: mode, locker: locker, details: window.ES_ADDITIONAL_DETAILS }; } };
})();
